export default __webpack_public_path__ + "static/company-history-building-sq-543e099044093372283a55d4192c99c2.jpg";